import { useQuery } from "@apollo/client";
import { gql } from "generated-graphql";

/** One page of the live organizations whose Encamp-only alerts reach no staff member. */
export const UNREACHED_ORGANIZATIONS = gql(`
  query UnreachedOrganizations($search: String, $page: Int, $pageSize: Int, $sort: [SortModel!]) {
    unreachedOrganizations(search: $search, page: $page, pageSize: $pageSize, sort: $sort) {
      items {
        tenantId
        name
        reason
        people {
          userId
          name
          roles
          state
        }
      }
      count
    }
  }
`);

/** How many organizations reach no one, unsearched. */
export const UNREACHED_ORGANIZATION_COUNT = gql(`
  query UnreachedOrganizationCount {
    unreachedOrganizations {
      count
    }
  }
`);

/**
 * The count, fetched again on every visit. Subscribing, unsubscribing and alert settings
 * change it from other pages, and a cached answer would hide that.
 */
export function useUnreachedOrganizationCount(): number | undefined {
  const { data } = useQuery(UNREACHED_ORGANIZATION_COUNT, { fetchPolicy: "cache-and-network" });
  return data?.unreachedOrganizations.count;
}
